.demoDevice {
  --device-padding: 1rem;
  --device-width: 370px;
  --device-height: 760px;
  --device-frame-width: 12px;
  /* padding: var(--device-padding); */
  position: -webkit-sticky;
  /* position: fixed; */
  /* top: 66px; */
  transform: scale3d(0.7,0.7,0.7);
  transform-origin: top;
  filter: none; 
}

@media only screen and (min-width: 1700px) {
  .demoDevice {
    transform: scale3d(1, 1, 1);
  }
}


.demoDevice > figure {
  margin: 0;
  background-size: contain;
  background-repeat: no-repeat;
  -webkit-box-shadow: 0px 2px 8px rgba(2, 8, 20, 0.1),
    0px 8px 16px rgba(2, 8, 20, 0.08);
  box-shadow: 0px 2px 8px rgba(2, 8, 20, 0.1), 0px 8px 16px rgba(2, 8, 20, 0.08);
  width: var(--device-width);
  height: var(--device-height);
  overflow: hidden;
  position: relative;
  z-index: 1;
  border: 10px solid black;
}

.demoDevice > figure > iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  overflow: hidden;
  z-index: 1;
}

.demoDevice.ios figure {
  border-radius: 54px;
}

.demoDevice.ios > figure > iframe {
  border-radius: 38px;
}

.demoDevice.ios figure:after {
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 2px;
  bottom: 6px;
  content: '';
  display: none;
  height: 4px;
  left: 50%;
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 35%;
  z-index: 1;
}

.demoDeviceNotch {
  display: none;
  fill: #090a0d;
  left: 50%;
  position: absolute;
  top: 0;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 165px;
  z-index: 2;
}

.demoDevice.ios .demoDeviceNotch,
.demoDevice.ios figure:after {
  display: block;
}

.demoDeviceBar {
  display: none;
}